import {BaseModel} from "@/model/BaseModel";
import {Product} from "@/model/Product";

/**
 * @property {string} AccountNumber
 * @property {string} Address
 * @property {string} CompanyName
 * @property {string} ContactPerson
 * @property {string} Manager
 * @property {string} Phone
 * @property {string} TaxNo
 * @property {boolean} IsActive
 * @property {boolean} HasPrivelege
 * @property {string} Type
 * @property {string} Comment
 * @property {string} Dealer
 * @property {string} VatNo
 * @property {string} BankAddress
 * @property {string} BankName
 * @property {string} MFO
 * @property {string} OKED
 */
export class Company extends BaseModel {

    static fields = [
        'setAccountNumber',
        'setAddress',
        'setCompanyName',
        'setContactPerson',
        'setManager',
        'setPhone',
        'setTaxNo',
        'setIsActive',
        'setHasPrivelege',
        'setType',
        'setComment',
        'setDealer',
        'setVatNo',
        'setBankAddress',
        'setBankName',
        'setMFO',
        'setOKED'
    ]

    /**
     * @param {Object} company
     */
    constructor(company = {}) {
        super(company, Company.fields)
    }

}